import { Action } from '@ngrx/store';
import { LoyaltyCurrency } from '@rd/types';

export enum LoyaltyCurrencyActionTypes {
  CHANGE_LOYALTY_CURRENCY = '[LoyaltyCurrency] Change LoyaltyCurrency',
}

export class ChangeLoyaltyCurrency implements Action {
  readonly type = LoyaltyCurrencyActionTypes.CHANGE_LOYALTY_CURRENCY;

  constructor(public payload: LoyaltyCurrency) {}
}

export type LoyaltyCurrencyActions = ChangeLoyaltyCurrency;
